import { GetRequest, PostRequest } from "../service";

const ControllerName = 'OrderConversation'

export const GetMedicalOrderMessages = (orderId) => 
     GetRequest(`${ControllerName}/hospitalOrder/${orderId}`)

export const SendMedicalOrderMessage = (orderId ,requestBody)  => 
    PostRequest(`${ControllerName}/hospitalOrder/${orderId}`, requestBody)
